import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { HrefResolverService } from '@blk/cwp-ng-framework';
import { DzModalConfig, DzModalRef } from '@blk/daisy/modules/modals';
import { PortfolioEditorMode } from '@ddt-web/config';
import { InjectConfig, PeConfigKey, SharedConfigKey } from '@ddt-web/config-layer';
import { UrlRedirectService } from '@ddt-web/url';
import * as chunk from 'lodash/chunk';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'mp-response-message-dialog',
	templateUrl: './response-message-dialog.component.html',
	styleUrls: ['./response-message-dialog.component.scss']
})
export class ResponseMessageDialogComponent implements OnInit {
	@InjectConfig(SharedConfigKey.ERROR_LISTINGS_LIMIT_PER_GROUP) private readonly errorListingsLimitPerGroup: number = 15;
	@InjectConfig(PeConfigKey.USE_STANDALONE_PE) private readonly useStandalonePe: boolean = false;


	public listingsGroups: string[][];

	public dataColumnClass: string;
	public listingsColumnClass: string;
	public imagePath: string;
	public data: any;

	constructor(
		private urlRedirectService: UrlRedirectService,
		private hrefResolverService: HrefResolverService,
		public dialogRef: DzModalRef,
		private dzModalConfig: DzModalConfig,
		private sanitizer: DomSanitizer
	) {
		this.data = this.dzModalConfig.contentData;
		if (this.data === undefined && this.data.message === undefined) {
			console.log('You need to supply an error message. Defaulting to empty string!');
		}

		this.imagePath = this.data.message.success ? 'Confirmation_check.svg' : 'Alert_warning.svg';
	}

	public ngOnInit(): void {
		if (this.data.message.listings) {
			this.groupListings(this.data.message.listings);
		}
		if (this.data.message.actions) {
			this.assignColumnClasses(this.data.message.actions.length);
		}
	}

	public directToPage(action: any): void {
		this.dialogRef.close();
		if (action.type === 'view_portfolio_editor') {
			this.urlRedirectService.redirectToPortfolioEditorView(
				{
					mode: PortfolioEditorMode.EDIT,
					portfolioIds: action.portfolioId,
					standaloneApp: this.useStandalonePe
				});
		} else if (action.type === 'max_portfolios_limit') {
			this.urlRedirectService.redirectToUrlWithQueryParam(action.url, action.params, true);
		} else if (action.type === 'review_dismissed_funds') {
			this.urlRedirectService.redirectToIqInvestmentDetails(action.params, 'dismiss');
		} else if (action.url) {
			window.location.href = action.url;
		} else if (action.type === 'resolve' && action.unresolvedUrl) {
			window.location.href = this.hrefResolverService.getResolvedUrl(action.unresolvedUrl);
		} else if (action.type === 'continue') {
			this.dialogRef.close();
		} else if (action.params && action.params.length) {
			if (action.type === 'compare_base') {
				this.urlRedirectService.redirectToOverviewTab(action.params, true, true);
			} else if (action.type === 'view_customised') {
				this.urlRedirectService.redirectToOverviewTab([action.params], true, true);
			} else if (action.type === 'model_rebalance') {
				this.urlRedirectService.redirectToRebalancePage(action.params);
			}
		} else if (action.type === 'view_library') {
			window.location.href = this.hrefResolverService.getResolvedUrl('portfolioLibraryPage');
		} else if (action.type === 'view_new_analysis') {
			this.urlRedirectService.redirectToNewAnalysisPage();
		} else if (action.reload) {
			window.location.reload();
		} else if (action.type === 'view_360') {
			this.urlRedirectService.redirectTo360AnalysisUsingWindow(
				this.hrefResolverService.getResolvedUrl('portfolioAnalyserPage'),
				action.portfolioId
			);
		} else {
			console.log('Missing url or params for redirect action!');
		}
	}

	public getTrackMsg(actionLabel: string): string {
		return this.data.message.trackMsgPrefix ? this.data.message.trackMsgPrefix + actionLabel : actionLabel;
	}

	public getAnchorLinkUrl(): SafeUrl {
		return this.sanitizer.bypassSecurityTrustUrl(this.data.message.anchorLink.url);
	}

	public closeDialog(): void {
		this.dialogRef.close();
	}

	private groupListings(listings: string[]): void {
		this.listingsGroups = chunk(listings, this.errorListingsLimitPerGroup);
		this.assignListingsColumnClasses(this.listingsGroups.length);
	}

	private assignColumnClasses(index: number): void {
		switch (index) {
			case 1:
				this.dataColumnClass = 'col-24';
				break;
			case 2:
				this.dataColumnClass = 'col-12';
				break;
			case 3:
				this.dataColumnClass = 'col-8';
				break;
			case 4:
				this.dataColumnClass = 'col-6';
				break;
			case 5:
				this.dataColumnClass = 'col-4';
				break;
		}
	}

	private assignListingsColumnClasses(numberOfListings: number): void {
		switch (numberOfListings) {
			case 1:
				this.listingsColumnClass = 'col-24';
				break;
			case 2:
				this.listingsColumnClass = 'col-12';
				break;
			case 3:
				this.listingsColumnClass = 'col-8';
				break;
			case 4:
				this.listingsColumnClass = 'col-6';
				break;
			case 5:
			case 6:
			default:
				this.listingsColumnClass = 'col-4';
				break;
		}
	}
}
